/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptInventoryCandidateRequest } from '../models/AcceptInventoryCandidateRequest';
import type { Body_upload_inventory_count_photo_endpoint_api_v1_inventory_tasks__task_id__entries__entry_id__photos_post } from '../models/Body_upload_inventory_count_photo_endpoint_api_v1_inventory_tasks__task_id__entries__entry_id__photos_post';
import type { BulkAcceptInventoryCandidatesRequest } from '../models/BulkAcceptInventoryCandidatesRequest';
import type { BulkOutOfStockInventoryRequest } from '../models/BulkOutOfStockInventoryRequest';
import type { CancelInventoryTaskRequest } from '../models/CancelInventoryTaskRequest';
import type { ConfirmInventoryCountLineRequest } from '../models/ConfirmInventoryCountLineRequest';
import type { CreateInventoryCategoryRequest } from '../models/CreateInventoryCategoryRequest';
import type { CreateInventoryCountEntryRequest } from '../models/CreateInventoryCountEntryRequest';
import type { CreateInventoryTaskRequest } from '../models/CreateInventoryTaskRequest';
import type { CreateSupplierRequest } from '../models/CreateSupplierRequest';
import type { DeleteInventoryCategoryRequest } from '../models/DeleteInventoryCategoryRequest';
import type { DeleteInventoryCountEntryRequest } from '../models/DeleteInventoryCountEntryRequest';
import type { DisableSupplierRequest } from '../models/DisableSupplierRequest';
import type { FinanceLockInventoryTaskRequest } from '../models/FinanceLockInventoryTaskRequest';
import type { FinanceReturnInventoryTaskRequest } from '../models/FinanceReturnInventoryTaskRequest';
import type { IgnoreInventoryCandidateRequest } from '../models/IgnoreInventoryCandidateRequest';
import type { InventoryCountPhotoBase64UploadRequest } from '../models/InventoryCountPhotoBase64UploadRequest';
import type { InventorySpotListWrite } from '../models/InventorySpotListWrite';
import type { InventoryTaskPolicyPatchRequest } from '../models/InventoryTaskPolicyPatchRequest';
import type { MergeInventoryCandidateRequest } from '../models/MergeInventoryCandidateRequest';
import type { PublishInventoryTaskRequest } from '../models/PublishInventoryTaskRequest';
import type { ReorderInventoryCategoriesRequest } from '../models/ReorderInventoryCategoriesRequest';
import type { ReturnInventoryTaskToCountingRequest } from '../models/ReturnInventoryTaskToCountingRequest';
import type { SubmitInventoryTaskForFinanceRequest } from '../models/SubmitInventoryTaskForFinanceRequest';
import type { SubmitInventoryTaskForManagerRequest } from '../models/SubmitInventoryTaskForManagerRequest';
import type { SuccessResponse_BulkOutOfStockInventoryResponse_ } from '../models/SuccessResponse_BulkOutOfStockInventoryResponse_';
import type { SuccessResponse_InventoryAdminSummaryResponse_ } from '../models/SuccessResponse_InventoryAdminSummaryResponse_';
import type { SuccessResponse_InventoryCategoryTreeResponse_ } from '../models/SuccessResponse_InventoryCategoryTreeResponse_';
import type { SuccessResponse_InventoryCountEntryListResponse_ } from '../models/SuccessResponse_InventoryCountEntryListResponse_';
import type { SuccessResponse_InventoryCountEntryResponse_ } from '../models/SuccessResponse_InventoryCountEntryResponse_';
import type { SuccessResponse_InventoryCountLineListResponse_ } from '../models/SuccessResponse_InventoryCountLineListResponse_';
import type { SuccessResponse_InventoryCountLineResponse_ } from '../models/SuccessResponse_InventoryCountLineResponse_';
import type { SuccessResponse_InventoryCountPhotoListResponse_ } from '../models/SuccessResponse_InventoryCountPhotoListResponse_';
import type { SuccessResponse_InventoryCountSummaryResponse_ } from '../models/SuccessResponse_InventoryCountSummaryResponse_';
import type { SuccessResponse_InventorySpotListItem_ } from '../models/SuccessResponse_InventorySpotListItem_';
import type { SuccessResponse_InventorySpotListResponse_ } from '../models/SuccessResponse_InventorySpotListResponse_';
import type { SuccessResponse_InventoryTaskDetailResponse_ } from '../models/SuccessResponse_InventoryTaskDetailResponse_';
import type { SuccessResponse_InventoryTaskListResponse_ } from '../models/SuccessResponse_InventoryTaskListResponse_';
import type { SuccessResponse_InventoryUnfilledResponse_ } from '../models/SuccessResponse_InventoryUnfilledResponse_';
import type { SupplierOnboardingRequest } from '../models/SupplierOnboardingRequest';
import type { SupplierProductAddRequest } from '../models/SupplierProductAddRequest';
import type { UpdateInventoryCategoryRequest } from '../models/UpdateInventoryCategoryRequest';
import type { UpdateInventoryCountEntryRequest } from '../models/UpdateInventoryCountEntryRequest';
import type { UpdateInventoryCountLineRequest } from '../models/UpdateInventoryCountLineRequest';
import type { UpdateInventoryTaskAssigneesRequest } from '../models/UpdateInventoryTaskAssigneesRequest';
import type { UpdateSupplierRequest } from '../models/UpdateSupplierRequest';
import type { VoidInventoryCountEntryRequest } from '../models/VoidInventoryCountEntryRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InventoryService {
    /**
     * List Inventory Categories Endpoint
     * @returns SuccessResponse_InventoryCategoryTreeResponse_ Successful Response
     * @throws ApiError
     */
    public static listInventoryCategoriesEndpointApiV1InventoryCategoriesGet({
        scopeType,
        brandKey,
        storeId,
    }: {
        scopeType?: ('global' | 'brand' | 'store' | null),
        brandKey?: (string | null),
        storeId?: (number | null),
    }): CancelablePromise<SuccessResponse_InventoryCategoryTreeResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/categories',
            query: {
                'scope_type': scopeType,
                'brand_key': brandKey,
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Inventory Category Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createInventoryCategoryEndpointApiV1InventoryCategoriesPost({
        requestBody,
    }: {
        requestBody: CreateInventoryCategoryRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/categories',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reorder Inventory Categories Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static reorderInventoryCategoriesEndpointApiV1InventoryCategoriesReorderPost({
        requestBody,
    }: {
        requestBody: ReorderInventoryCategoriesRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/categories/reorder',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Inventory Category Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateInventoryCategoryEndpointApiV1InventoryCategoriesCategoryIdPatch({
        categoryId,
        requestBody,
    }: {
        categoryId: number,
        requestBody: UpdateInventoryCategoryRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/inventory/categories/{category_id}',
            path: {
                'category_id': categoryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Inventory Category Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteInventoryCategoryEndpointApiV1InventoryCategoriesCategoryIdDelete({
        categoryId,
        requestBody,
    }: {
        categoryId: number,
        requestBody: DeleteInventoryCategoryRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/inventory/categories/{category_id}',
            path: {
                'category_id': categoryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Suppliers Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static listSuppliersEndpointApiV1InventorySuppliersGet({
        status,
        supplierType,
        scopeType,
        storeId,
        q,
        limit = 50,
        offset,
    }: {
        status?: ('pending' | 'active' | 'disabled' | null),
        supplierType?: ('company' | 'store_self' | null),
        scopeType?: ('brand' | 'store' | null),
        storeId?: (number | null),
        q?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/suppliers',
            query: {
                'status': status,
                'supplier_type': supplierType,
                'scope_type': scopeType,
                'store_id': storeId,
                'q': q,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Supplier Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createSupplierEndpointApiV1InventorySuppliersPost({
        requestBody,
    }: {
        requestBody: CreateSupplierRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/suppliers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Supplier Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getSupplierEndpointApiV1InventorySuppliersSupplierIdGet({
        supplierId,
    }: {
        supplierId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/suppliers/{supplier_id}',
            path: {
                'supplier_id': supplierId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Supplier Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateSupplierEndpointApiV1InventorySuppliersSupplierIdPatch({
        supplierId,
        requestBody,
    }: {
        supplierId: number,
        requestBody: UpdateSupplierRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/inventory/suppliers/{supplier_id}',
            path: {
                'supplier_id': supplierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Disable Supplier Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static disableSupplierEndpointApiV1InventorySuppliersSupplierIdDisablePost({
        supplierId,
        requestBody,
    }: {
        supplierId: number,
        requestBody: DisableSupplierRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/suppliers/{supplier_id}/disable',
            path: {
                'supplier_id': supplierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit Supplier Onboarding Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static submitSupplierOnboardingEndpointApiV1InventorySuppliersOnboardingRequestsPost({
        requestBody,
    }: {
        requestBody: SupplierOnboardingRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/suppliers/onboarding-requests',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit Supplier Product Add Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static submitSupplierProductAddEndpointApiV1InventorySuppliersSupplierIdProductAddRequestsPost({
        supplierId,
        requestBody,
    }: {
        supplierId: number,
        requestBody: SupplierProductAddRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/suppliers/{supplier_id}/product-add-requests',
            path: {
                'supplier_id': supplierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Launch Inventory Admin Task Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static launchInventoryAdminTaskEndpointApiV1InventoryAdminTasksLaunchPost({
        requestBody,
    }: {
        requestBody: CreateInventoryTaskRequest,
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/admin/tasks/launch',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Inventory Spot List Endpoint
     * @returns SuccessResponse_InventorySpotListResponse_ Successful Response
     * @throws ApiError
     */
    public static listInventorySpotListEndpointApiV1InventoryAdminSpotListGet({
        storeId,
        q,
        brandKey,
    }: {
        storeId: number,
        q?: (string | null),
        brandKey?: ('yin_san_shun' | 'qiao_jiang_xi' | null),
    }): CancelablePromise<SuccessResponse_InventorySpotListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/admin/spot-list',
            query: {
                'store_id': storeId,
                'q': q,
                'brand_key': brandKey,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Inventory Spot List Endpoint
     * @returns SuccessResponse_InventorySpotListItem_ Successful Response
     * @throws ApiError
     */
    public static addInventorySpotListEndpointApiV1InventoryAdminSpotListPost({
        requestBody,
    }: {
        requestBody: InventorySpotListWrite,
    }): CancelablePromise<SuccessResponse_InventorySpotListItem_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/admin/spot-list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Remove Inventory Spot List Endpoint
     * @returns void
     * @throws ApiError
     */
    public static removeInventorySpotListEndpointApiV1InventoryAdminSpotListSpotItemIdDelete({
        spotItemId,
        version,
    }: {
        spotItemId: number,
        version: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/inventory/admin/spot-list/{spot_item_id}',
            path: {
                'spot_item_id': spotItemId,
            },
            query: {
                'version': version,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Complete Weekly Inventory Task Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static completeWeeklyInventoryTaskEndpointApiV1InventoryTasksTaskIdCompleteWeeklyPost({
        taskId,
        requestBody,
    }: {
        taskId: number,
        requestBody: PublishInventoryTaskRequest,
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/tasks/{task_id}/complete-weekly',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Weekly Spot Report Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static exportWeeklySpotReportEndpointApiV1InventoryAdminTasksTaskIdWeeklyReportXlsxGet({
        taskId,
    }: {
        taskId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/admin/tasks/{task_id}/weekly-report.xlsx',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List My Inventory Tasks Endpoint
     * @returns SuccessResponse_InventoryTaskListResponse_ Successful Response
     * @throws ApiError
     */
    public static listMyInventoryTasksEndpointApiV1InventoryTasksMyGet({
        status,
        storeId,
        limit = 50,
        offset,
    }: {
        status?: ('draft' | 'counting' | 'manager_review' | 'manager_returned' | 'finance_review' | 'finance_returned' | 'locked' | 'corrected' | 'cancelled' | null),
        /**
         * 可选: 在既有可见范围内收窄到单店 (异常下钻 / owner 看某店)。owner/area/super_admin 传任意店在其 scope 内收窄; area 传名下外店被 conditions 自然排空; store_manager 传非本店 403 (不放宽 scoping)。
         */
        storeId?: (number | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<SuccessResponse_InventoryTaskListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/tasks/my',
            query: {
                'status': status,
                'store_id': storeId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Inventory Task Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static getInventoryTaskEndpointApiV1InventoryTasksTaskIdGet({
        taskId,
    }: {
        taskId: number,
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/tasks/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Cancel Inventory Task Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static cancelInventoryTaskEndpointApiV1InventoryTasksTaskIdCancelPost({
        taskId,
        requestBody,
    }: {
        taskId: number,
        requestBody: CancelInventoryTaskRequest,
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/tasks/{task_id}/cancel',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Inventory Task Lines Endpoint
     * @returns SuccessResponse_InventoryCountLineListResponse_ Successful Response
     * @throws ApiError
     */
    public static listInventoryTaskLinesEndpointApiV1InventoryTasksTaskIdLinesGet({
        taskId,
        filter,
        countedBy,
        limit = 200,
        offset,
    }: {
        taskId: number,
        filter?: ('diff' | 'missing_photo' | 'suspected_dup' | 'by_member' | null),
        countedBy?: (number | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<SuccessResponse_InventoryCountLineListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/tasks/{task_id}/lines',
            path: {
                'task_id': taskId,
            },
            query: {
                'filter': filter,
                'counted_by': countedBy,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Inventory Count Entries Endpoint
     * @returns SuccessResponse_InventoryCountEntryListResponse_ Successful Response
     * @throws ApiError
     */
    public static listInventoryCountEntriesEndpointApiV1InventoryTasksTaskIdEntriesGet({
        taskId,
        lineId,
        countedBy,
        entryStatus,
        sinceEntryId,
        throughEntryId,
        limit = 100,
        offset,
    }: {
        taskId: number,
        lineId?: (number | null),
        countedBy?: (number | null),
        entryStatus?: ('active' | 'superseded' | 'voided' | null),
        sinceEntryId?: (number | null),
        throughEntryId?: (number | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<SuccessResponse_InventoryCountEntryListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/tasks/{task_id}/entries',
            path: {
                'task_id': taskId,
            },
            query: {
                'line_id': lineId,
                'counted_by': countedBy,
                'entry_status': entryStatus,
                'since_entry_id': sinceEntryId,
                'through_entry_id': throughEntryId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Inventory Count Entry Endpoint
     * @returns SuccessResponse_InventoryCountEntryResponse_ Successful Response
     * @throws ApiError
     */
    public static createInventoryCountEntryEndpointApiV1InventoryTasksTaskIdEntriesPost({
        taskId,
        requestBody,
        xEmberInstallationCredential,
    }: {
        taskId: number,
        requestBody: CreateInventoryCountEntryRequest,
        xEmberInstallationCredential?: (string | null),
    }): CancelablePromise<SuccessResponse_InventoryCountEntryResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/tasks/{task_id}/entries',
            path: {
                'task_id': taskId,
            },
            headers: {
                'X-Ember-Installation-Credential': xEmberInstallationCredential,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Inventory Count Entry Endpoint
     * @returns SuccessResponse_InventoryCountEntryResponse_ Successful Response
     * @throws ApiError
     */
    public static createInventoryCountEntryEndpointApiV1InventoryTasksTaskIdEntriesPut({
        taskId,
        requestBody,
        xEmberInstallationCredential,
    }: {
        taskId: number,
        requestBody: CreateInventoryCountEntryRequest,
        xEmberInstallationCredential?: (string | null),
    }): CancelablePromise<SuccessResponse_InventoryCountEntryResponse_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/inventory/tasks/{task_id}/entries',
            path: {
                'task_id': taskId,
            },
            headers: {
                'X-Ember-Installation-Credential': xEmberInstallationCredential,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Inventory Count Entry Endpoint
     * @returns SuccessResponse_InventoryCountEntryResponse_ Successful Response
     * @throws ApiError
     */
    public static updateInventoryCountEntryEndpointApiV1InventoryTasksTaskIdEntriesEntryIdPatch({
        taskId,
        entryId,
        requestBody,
        xEmberInstallationCredential,
    }: {
        taskId: number,
        entryId: number,
        requestBody: UpdateInventoryCountEntryRequest,
        xEmberInstallationCredential?: (string | null),
    }): CancelablePromise<SuccessResponse_InventoryCountEntryResponse_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/inventory/tasks/{task_id}/entries/{entry_id}',
            path: {
                'task_id': taskId,
                'entry_id': entryId,
            },
            headers: {
                'X-Ember-Installation-Credential': xEmberInstallationCredential,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Inventory Count Entry Endpoint
     * @returns SuccessResponse_InventoryCountEntryResponse_ Successful Response
     * @throws ApiError
     */
    public static updateInventoryCountEntryEndpointApiV1InventoryTasksTaskIdEntriesEntryIdPut({
        taskId,
        entryId,
        requestBody,
        xEmberInstallationCredential,
    }: {
        taskId: number,
        entryId: number,
        requestBody: UpdateInventoryCountEntryRequest,
        xEmberInstallationCredential?: (string | null),
    }): CancelablePromise<SuccessResponse_InventoryCountEntryResponse_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/inventory/tasks/{task_id}/entries/{entry_id}',
            path: {
                'task_id': taskId,
                'entry_id': entryId,
            },
            headers: {
                'X-Ember-Installation-Credential': xEmberInstallationCredential,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Inventory Count Entry Endpoint
     * @returns SuccessResponse_InventoryCountEntryResponse_ Successful Response
     * @throws ApiError
     */
    public static deleteInventoryCountEntryEndpointApiV1InventoryTasksTaskIdEntriesEntryIdDelete({
        taskId,
        entryId,
        requestBody,
    }: {
        taskId: number,
        entryId: number,
        requestBody: DeleteInventoryCountEntryRequest,
    }): CancelablePromise<SuccessResponse_InventoryCountEntryResponse_> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/inventory/tasks/{task_id}/entries/{entry_id}',
            path: {
                'task_id': taskId,
                'entry_id': entryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Void Inventory Count Entry Endpoint
     * @returns SuccessResponse_InventoryCountEntryResponse_ Successful Response
     * @throws ApiError
     */
    public static voidInventoryCountEntryEndpointApiV1InventoryTasksTaskIdEntriesEntryIdVoidPost({
        taskId,
        entryId,
        requestBody,
    }: {
        taskId: number,
        entryId: number,
        requestBody: VoidInventoryCountEntryRequest,
    }): CancelablePromise<SuccessResponse_InventoryCountEntryResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/tasks/{task_id}/entries/{entry_id}/void',
            path: {
                'task_id': taskId,
                'entry_id': entryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Inventory Count Photo Endpoint
     * @returns SuccessResponse_InventoryCountEntryResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadInventoryCountPhotoEndpointApiV1InventoryTasksTaskIdEntriesEntryIdPhotosPost({
        taskId,
        entryId,
        formData,
    }: {
        taskId: number,
        entryId: number,
        formData: Body_upload_inventory_count_photo_endpoint_api_v1_inventory_tasks__task_id__entries__entry_id__photos_post,
    }): CancelablePromise<SuccessResponse_InventoryCountEntryResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/tasks/{task_id}/entries/{entry_id}/photos',
            path: {
                'task_id': taskId,
                'entry_id': entryId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Inventory Count Photo Base64 Endpoint
     * @returns SuccessResponse_InventoryCountEntryResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadInventoryCountPhotoBase64EndpointApiV1InventoryTasksTaskIdEntriesEntryIdPhotosBase64Post({
        taskId,
        entryId,
        requestBody,
    }: {
        taskId: number,
        entryId: number,
        requestBody: InventoryCountPhotoBase64UploadRequest,
    }): CancelablePromise<SuccessResponse_InventoryCountEntryResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/tasks/{task_id}/entries/{entry_id}/photos/base64',
            path: {
                'task_id': taskId,
                'entry_id': entryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Inventory Count Photo Content Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static inventoryCountPhotoContentEndpointApiV1InventoryTasksTaskIdPhotosPhotoIdContentGet({
        taskId,
        photoId,
        variant = 'original',
    }: {
        taskId: number,
        photoId: number,
        variant?: 'original' | 'thumb',
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/tasks/{task_id}/photos/{photo_id}/content',
            path: {
                'task_id': taskId,
                'photo_id': photoId,
            },
            query: {
                'variant': variant,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Previous Inventory Item Photos Endpoint
     * @returns SuccessResponse_InventoryCountPhotoListResponse_ Successful Response
     * @throws ApiError
     */
    public static listPreviousInventoryItemPhotosEndpointApiV1InventoryItemsItemIdPreviousPhotosGet({
        itemId,
        storeId,
        limit = 20,
    }: {
        itemId: number,
        storeId?: (number | null),
        limit?: number,
    }): CancelablePromise<SuccessResponse_InventoryCountPhotoListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/items/{item_id}/previous-photos',
            path: {
                'item_id': itemId,
            },
            query: {
                'store_id': storeId,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Inventory Count Photo Content By Id Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static inventoryCountPhotoContentByIdEndpointApiV1InventoryPhotosPhotoIdContentGet({
        photoId,
        variant = 'original',
    }: {
        photoId: number,
        variant?: 'original' | 'thumb',
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/photos/{photo_id}/content',
            path: {
                'photo_id': photoId,
            },
            query: {
                'variant': variant,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Inventory Unfilled Items Endpoint
     * @returns SuccessResponse_InventoryUnfilledResponse_ Successful Response
     * @throws ApiError
     */
    public static getInventoryUnfilledItemsEndpointApiV1InventoryTasksTaskIdUnfilledGet({
        taskId,
    }: {
        taskId: number,
    }): CancelablePromise<SuccessResponse_InventoryUnfilledResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/tasks/{task_id}/unfilled',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Inventory Count Summary Endpoint
     * @returns SuccessResponse_InventoryCountSummaryResponse_ Successful Response
     * @throws ApiError
     */
    public static getInventoryCountSummaryEndpointApiV1InventoryTasksTaskIdSummaryGet({
        taskId,
    }: {
        taskId: number,
    }): CancelablePromise<SuccessResponse_InventoryCountSummaryResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/tasks/{task_id}/summary',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Inventory Task Assignees Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static updateInventoryTaskAssigneesEndpointApiV1InventoryTasksTaskIdAssigneesPut({
        taskId,
        requestBody,
    }: {
        taskId: number,
        requestBody: UpdateInventoryTaskAssigneesRequest,
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/inventory/tasks/{task_id}/assignees',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Inventory Count Line Endpoint
     * @returns SuccessResponse_InventoryCountLineResponse_ Successful Response
     * @throws ApiError
     */
    public static updateInventoryCountLineEndpointApiV1InventoryTasksTaskIdLinesLineIdUpdatePost({
        taskId,
        lineId,
        requestBody,
    }: {
        taskId: number,
        lineId: number,
        requestBody: UpdateInventoryCountLineRequest,
    }): CancelablePromise<SuccessResponse_InventoryCountLineResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/tasks/{task_id}/lines/{line_id}/update',
            path: {
                'task_id': taskId,
                'line_id': lineId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Inventory Count Line Endpoint
     * @returns SuccessResponse_InventoryCountLineResponse_ Successful Response
     * @throws ApiError
     */
    public static updateInventoryCountLineEndpointApiV1InventoryTasksTaskIdLinesLineIdPatch({
        taskId,
        lineId,
        requestBody,
    }: {
        taskId: number,
        lineId: number,
        requestBody: UpdateInventoryCountLineRequest,
    }): CancelablePromise<SuccessResponse_InventoryCountLineResponse_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/inventory/tasks/{task_id}/lines/{line_id}',
            path: {
                'task_id': taskId,
                'line_id': lineId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Confirm Inventory Count Line Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static confirmInventoryCountLineEndpointApiV1InventoryTasksTaskIdLinesLineIdConfirmPost({
        taskId,
        lineId,
        requestBody,
    }: {
        taskId: number,
        lineId: number,
        requestBody: ConfirmInventoryCountLineRequest,
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/tasks/{task_id}/lines/{line_id}/confirm',
            path: {
                'task_id': taskId,
                'line_id': lineId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Inventory Task Policy Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static patchInventoryTaskPolicyEndpointApiV1InventoryTasksTaskIdPolicyPatch({
        taskId,
        requestBody,
    }: {
        taskId: number,
        requestBody: InventoryTaskPolicyPatchRequest,
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/inventory/tasks/{task_id}/policy',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit Inventory Task For Manager Review Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static submitInventoryTaskForManagerReviewEndpointApiV1InventoryTasksTaskIdSubmitManagerReviewPost({
        taskId,
        requestBody,
        xEmberInstallationCredential,
    }: {
        taskId: number,
        requestBody: SubmitInventoryTaskForManagerRequest,
        xEmberInstallationCredential?: (string | null),
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/tasks/{task_id}/submit-manager-review',
            path: {
                'task_id': taskId,
            },
            headers: {
                'X-Ember-Installation-Credential': xEmberInstallationCredential,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Return Inventory Task To Counting Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static returnInventoryTaskToCountingEndpointApiV1InventoryTasksTaskIdManagerReturnPost({
        taskId,
        requestBody,
    }: {
        taskId: number,
        requestBody: ReturnInventoryTaskToCountingRequest,
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/tasks/{task_id}/manager-return',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit Inventory Task For Finance Review Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static submitInventoryTaskForFinanceReviewEndpointApiV1InventoryTasksTaskIdSubmitFinanceReviewPost({
        taskId,
        requestBody,
    }: {
        taskId: number,
        requestBody: SubmitInventoryTaskForFinanceRequest,
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/tasks/{task_id}/submit-finance-review',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Inventory Admin Summary Endpoint
     * @returns SuccessResponse_InventoryAdminSummaryResponse_ Successful Response
     * @throws ApiError
     */
    public static inventoryAdminSummaryEndpointApiV1InventoryAdminSummaryGet({
        storeId,
    }: {
        storeId?: (number | null),
    }): CancelablePromise<SuccessResponse_InventoryAdminSummaryResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/admin/summary',
            query: {
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Inventory Admin Tasks Endpoint
     * @returns SuccessResponse_InventoryTaskListResponse_ Successful Response
     * @throws ApiError
     */
    public static listInventoryAdminTasksEndpointApiV1InventoryAdminTasksGet({
        status,
        taskType,
        period,
        statusGroup,
        storeId,
        limit = 50,
        offset,
    }: {
        status?: ('draft' | 'counting' | 'manager_review' | 'manager_returned' | 'finance_review' | 'finance_returned' | 'locked' | 'corrected' | 'cancelled' | null),
        taskType?: ('monthly' | 'weekly' | 'ad_hoc' | null),
        period?: (string | null),
        statusGroup?: ('in_progress' | 'completed' | 'cancelled' | null),
        storeId?: (number | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<SuccessResponse_InventoryTaskListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/admin/tasks',
            query: {
                'status': status,
                'task_type': taskType,
                'period': period,
                'status_group': statusGroup,
                'store_id': storeId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Inventory Admin Task Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static createInventoryAdminTaskEndpointApiV1InventoryAdminTasksPost({
        requestBody,
    }: {
        requestBody: CreateInventoryTaskRequest,
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/admin/tasks',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Inventory Admin Task Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static getInventoryAdminTaskEndpointApiV1InventoryAdminTasksTaskIdGet({
        taskId,
    }: {
        taskId: number,
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/admin/tasks/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Publish Inventory Admin Task Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static publishInventoryAdminTaskEndpointApiV1InventoryAdminTasksTaskIdPublishPost({
        taskId,
        requestBody,
    }: {
        taskId: number,
        requestBody: PublishInventoryTaskRequest,
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/admin/tasks/{task_id}/publish',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Finance Return Inventory Task Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static financeReturnInventoryTaskEndpointApiV1InventoryAdminTasksTaskIdFinanceReturnPost({
        taskId,
        requestBody,
    }: {
        taskId: number,
        requestBody: FinanceReturnInventoryTaskRequest,
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/admin/tasks/{task_id}/finance-return',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Finance Lock Inventory Task Endpoint
     * @returns SuccessResponse_InventoryTaskDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static financeLockInventoryTaskEndpointApiV1InventoryAdminTasksTaskIdFinanceLockPost({
        taskId,
        requestBody,
    }: {
        taskId: number,
        requestBody: FinanceLockInventoryTaskRequest,
    }): CancelablePromise<SuccessResponse_InventoryTaskDetailResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/admin/tasks/{task_id}/finance-lock',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Inventory Tasks Endpoint
     * @returns binary 按当前筛选合并导出的库存盘点 xlsx
     * @throws ApiError
     */
    public static exportInventoryTasksEndpointApiV1InventoryAdminExportsGet({
        taskType,
        period,
        statusGroup,
    }: {
        taskType?: ('monthly' | 'weekly' | 'ad_hoc' | null),
        period?: (string | null),
        statusGroup?: ('in_progress' | 'completed' | 'cancelled' | null),
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/admin/exports',
            query: {
                'task_type': taskType,
                'period': period,
                'status_group': statusGroup,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Inventory Task Endpoint
     * @returns binary 单张库存盘点任务 xlsx
     * @throws ApiError
     */
    public static exportInventoryTaskEndpointApiV1InventoryAdminExportsTaskIdGet({
        taskId,
    }: {
        taskId: number,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/admin/exports/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Mark Remaining Out Of Stock Endpoint
     * @returns SuccessResponse_BulkOutOfStockInventoryResponse_ Successful Response
     * @throws ApiError
     */
    public static bulkMarkRemainingOutOfStockEndpointApiV1InventoryTasksTaskIdBulkOutOfStockPost({
        taskId,
        requestBody,
    }: {
        taskId: number,
        requestBody: BulkOutOfStockInventoryRequest,
    }): CancelablePromise<SuccessResponse_BulkOutOfStockInventoryResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/tasks/{task_id}/bulk-out-of-stock',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Item Candidates Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static listItemCandidatesEndpointApiV1InventoryAdminItemCandidatesGet({
        status,
        q,
        category,
        categoryId,
        supplierSource,
        supplierId,
        limit = 50,
        offset,
    }: {
        status?: ('pending' | 'accepted' | 'merged' | 'ignored' | null),
        q?: (string | null),
        category?: (string | null),
        categoryId?: (number | null),
        supplierSource?: (string | null),
        supplierId?: (number | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/admin/item-candidates',
            query: {
                'status': status,
                'q': q,
                'category': category,
                'category_id': categoryId,
                'supplier_source': supplierSource,
                'supplier_id': supplierId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Accept Item Candidate Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static acceptItemCandidateEndpointApiV1InventoryAdminItemCandidatesCandidateIdAcceptPost({
        candidateId,
        requestBody,
    }: {
        candidateId: number,
        requestBody: AcceptInventoryCandidateRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/admin/item-candidates/{candidate_id}/accept',
            path: {
                'candidate_id': candidateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Accept Item Candidates Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static bulkAcceptItemCandidatesEndpointApiV1InventoryAdminItemCandidatesBulkAcceptPost({
        requestBody,
    }: {
        requestBody: BulkAcceptInventoryCandidatesRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/admin/item-candidates/bulk-accept',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Ignore Item Candidate Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static ignoreItemCandidateEndpointApiV1InventoryAdminItemCandidatesCandidateIdIgnorePost({
        candidateId,
        requestBody,
    }: {
        candidateId: number,
        requestBody: IgnoreInventoryCandidateRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/admin/item-candidates/{candidate_id}/ignore',
            path: {
                'candidate_id': candidateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Merge Item Candidate Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static mergeItemCandidateEndpointApiV1InventoryAdminItemCandidatesCandidateIdMergePost({
        candidateId,
        requestBody,
    }: {
        candidateId: number,
        requestBody: MergeInventoryCandidateRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inventory/admin/item-candidates/{candidate_id}/merge',
            path: {
                'candidate_id': candidateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Inventory Items Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static listInventoryItemsEndpointApiV1InventoryAdminItemsGet({
        status,
        storeId,
        q,
        category,
        categoryId,
        supplierSource,
        supplierId,
        limit = 50,
        offset,
    }: {
        status?: ('candidate' | 'active' | 'disabled' | 'merged' | null),
        storeId?: (number | null),
        q?: (string | null),
        category?: (string | null),
        categoryId?: (number | null),
        supplierSource?: (string | null),
        supplierId?: (number | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inventory/admin/items',
            query: {
                'status': status,
                'store_id': storeId,
                'q': q,
                'category': category,
                'category_id': categoryId,
                'supplier_source': supplierSource,
                'supplier_id': supplierId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
